<template>
  <div class="wrapper">
    <div class="tips">
      欢迎您浏览和使用金箱科技app，请仔细阅读以下法律条款
      。如果您使用此app,您已被视为接收和统一遵从这些条款。
    </div>
    <div class="content">
      <div class="container">
        <div>
          金箱科技app包含的商标属深圳金箱科技有限公司及其
          关联公司所有和使用，受国内和国际法的保护，未经授权， 不得复制和仿造。
        </div>
        <div>
          金箱科技app中所有设计、文字或图案等，均属深圳金箱科
          技有限公司所有、或已取得所有人的正式授权。
          在未取得相关权利人的书面同意之前，任何人不得以任何形
          式复制,复印、传送、分发、修改金箱科技app上所载的内容。
        </div>
        <div>
          金箱科技app将尽可能提供准确和及时的信息和内容，但并
          不能保证绝对正确无误。因此，在法律允许的范围内，金箱
          科技app对信息的准确性和及时性不给予任何明示 或者默示
          的保证。金箱科技app，不承担您进入或使用本网站而导致
          任何直接的、间接的、意外的、因果性的损害责任。
        </div>
        <div>
          请小心 使用您的软甲和设备。此外，金箱科技app对您提供便利而
          设置的外部衔接内容不负任何责任。深圳金箱科技有限
          公司有权未经通知金箱科技app的用户，而对金箱科技app
          的内容做修改。您可以自愿选择是否在金箱而科技app提交
          个人信息资料。如果您在金箱科技提交个人资料，金箱科技
          app，将对于您的个人资料和隐私权予以尊重和保密。
        </div>
        <div>
          在您 的信息被用于金箱科技的调查、统计、内部整体使用、发送
          促销信息的情况下，金箱科技app可能会自动收集不足以使
          他人辨认您个人身份的技术性资料或在您的硬盘上存储少量
          的数据，上述行为的目的旨在为您提供更完善的服务。
        </div>
        <div>
          金箱科技app禁止您在金箱科技app传送和发放带有中伤、
          诽谤、造谣、色情及其他违法或不道德的资料和言论，金箱
          科技app有权对此进行管理和监督，但并不对此承担任何责
          任。金箱科技app无意向18岁以下未成年人收集个人资料，
          并请家长或监护人对其子女在使用互联网时进行监管和负责。
          由于金箱亏app无法辨认用户是否为成年人，因此如果有未
          成年人使用金箱科技app网上冲浪服务，金箱科技app将视
          为获得其家长或监护人认可，任何相关后果与app无关。
        </div>
      </div>
      <div class="documentName">
        文档名称：
        <div>法律条文</div>
      </div>
      <div class="updateDate">版本更新日期：2022-8-26</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
@import "./introduction.less";
</style>
